module.exports = __webpack_public_path__ + "img/sync.2f78cb58.svg";